import geometryTools from "utils/geometryTools";
import ItemDetail from "components/SearchResult/ItemDetail";
import React from "react";
import slopeNoFormat from "utils/slopeNoFormat";

class openFromUrlForResult {
  static openFromUrl() {
    let slopeNo = this.simpleCheckUrlHash();
    slopeNo = slopeNo && slopeNoFormat.FeatureNo13Char(slopeNo);
    return slopeNo;
  }
  static simpleCheckUrlHash() {
    let setting = window.location.hash.substring(1);
    if (setting != "") {
      let para = decodeURI(setting);
      if (this.validateUrlHash(para)) {
        console.log("url para", para);
        return para;
      }
    }
  }
  static validateUrlHash(para) {
    if (typeof para != "string") {
      return false;
    } else if (typeof para.length === "undefined") {
      return false;
    } else if (para.length === 0) {
      return false;
    }
    return true;
  }

  static turnOn3DLayers(slopeNo, mapView) {
    let props = { mapView };
    let component = React.createElement(ItemDetail, props);
    let instance = new component.type(props);
    instance.props = props;

    instance.showRelated3DLayer(slopeNo);
  }

  static async searchForSlope(slopeNo, mapView) {
    let targetSearchLayer = mapView.map.allLayers.find(
      (i) => i.title === "Man Made Slope - Query"
    );
    if (!targetSearchLayer) return;
    let result = await targetSearchLayer.queryFeatures({
      where: `SLOPE_NO = '${slopeNo}'`,
      returnGeometry: true,
    });
    if (result.features.length > 0) {
      geometryTools.createGraphicsLayerById(
        "GLayerForCompactMode",
        mapView.map
      );
      geometryTools.graphicFuncMain(
        mapView,
        "GLayerForCompactMode",
        result.features.map((i) => i.geometry),
        true
      );
      openFromUrlForResult.turnOn3DLayers(slopeNo, mapView);
    }
  }
}
export default openFromUrlForResult;
